var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-ui-state-loader"},[_c('section',{staticClass:"text-center"},[_c('img',{attrs:{"src":require("@chalkysticks/sass/build/asset/image/loader/triangle-white.svg")}})])])
}]

export { render, staticRenderFns }